import { store } from '@wordpress/interactivity';

const { state } = store('mediapress-listicle', {
  state: {
    get hideLoadMore() {
      return state.totalPages === state.page;
    },
  },
  actions: {
    loadMore: () => {
      const nextPage = state.page + 1;

      state.page = nextPage;
      state.selectedPage = nextPage;
    },
  },
});
